document.addEventListener("DOMContentLoaded", function () {
  //   ------------ product Carousels ---------------
  const productCarousels = document.querySelectorAll(".spp-carousel");
  let swiperInstances = {}; // store all swiper instances

  if (productCarousels) {
    productCarousels.forEach((carousel) => {
      const nextButton = carousel.parentElement.querySelector(
        ".swiper-button-next"
      );

      const prevButton = carousel.parentElement.querySelector(
        ".swiper-button-prev"
      );

      const productSelector = carousel.getAttribute("data-product-selector");
      const selectorName = carousel.getAttribute("data-selector-name");
      const form = document.getElementById("subscription-product-picker-form");
      const productVariantInput = document.querySelector(
        `.product-carousel input[name="id"]`
      );

      const handleProductVariantId = (swiper, direction) => {
        // function to handle product id for form if product has signel variant id
        const activeProductSlide = document.querySelector(
          ".product-carousel .swiper-slide-active > button"
        );
        const singularVariantId = activeProductSlide?.getAttribute(
          "data-singular-variant-id"
        );
        const multiPackVariantId =
          activeProductSlide?.getAttribute("data-variant-id");
        if (productSelector === "false") {
          if (singularVariantId?.length <= 0 && swiper.realIndex === 0) {
            if (direction === "next") {
              swiper.slideNext(300);
            } else {
              swiper.slidePrev(300);
            }
          } else if (swiper.realIndex === 0) {
            productVariantInput.value = singularVariantId;
          } else {
            productVariantInput.value = multiPackVariantId;
          }
        }
      };

      const productGallery = new Swiper(carousel, {
        direction: "horizontal",
        spaceBetween: 8,
        allowTouchMove: true,
        loop: true,
        slidesPerView: 2.5,
        initialSlide: productSelector === "true" ? 0 : 1,
        breakpoints: {
          1024: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
        },
        on: {
          slideChange: function () {
            const index = this.realIndex;
            const activeSlide = this.slides[this.activeIndex];

            if (productSelector === "true") {
              // Update price

              if (activeSlide) {
                const price = activeSlide
                  .querySelector("button")
                  .getAttribute("data-price");
                const toGBP = (pence) =>
                  new Intl.NumberFormat("en-GB", {
                    style: "currency",
                    currency: "GBP",
                  }).format(pence / 100);
                const standardPrice = toGBP(price);
                const discountPrice = toGBP(price * 0.9);
                const standardPriceElement = document.querySelector(
                  ".spp-standard-price .money"
                );
                const discountPriceElement = document.querySelector(
                  ".spp-discounted-price .money"
                );
                if (standardPriceElement) {
                  standardPriceElement.innerHTML = standardPrice;
                }
                if (discountPriceElement) {
                  discountPriceElement.innerHTML = discountPrice;
                }

                // if Product carousel changes to product without single variant id
                // then change quantity carousel to multi pack
                const hasSingularVariantId =
                  activeSlide
                    .querySelector("button")
                    .getAttribute("data-singular-variant-id")?.length > 0;
                if (
                  swiperInstances["quantity"]?.realIndex === 0 &&
                  !hasSingularVariantId
                ) {
                  setTimeout(() => {
                    swiperInstances["quantity"].slideNext(300);
                  }, 500);
                }
              }

              // Update input value on change like on btn click
              // even remove button click becasue it updates the slide
              const currActiveDescription = document.querySelector(
                ".product-description:not(.hidden)"
              );
              const currActiveMainCarousel = document.querySelector(
                ".spp-main-carousel-container:not(.hidden)"
              );
              currActiveDescription.classList.add("hidden");
              currActiveMainCarousel.classList.add("hidden");

              const newActiveDescription = document.querySelector(
                `.product-description[data-product-description="${index + 1}"]`
              );
              const newActiveMainCarousel = document.querySelector(
                `.spp-main-carousel-container[data-main-carousel="${
                  index + 1
                }"]`
              );

              newActiveDescription.classList.remove("hidden");
              newActiveMainCarousel.classList.remove("hidden");
            }

            // On new slide update hidden field with value for form
            if (!activeSlide) return;
            const selectorName = carousel.getAttribute("data-selector-name");

            const variantId =
              activeSlide.firstElementChild.getAttribute("data-variant-id");
            if (!variantId) return;

            const hidden = form.querySelector(`input[name="${selectorName}"]`);
            hidden.value = variantId;
          },
          slideChangeTransitionStart: function (swiper) {
            // Remove disabled syling from single carton if product has single variant id
            const activeProductSlide = document.querySelector(
              ".product-carousel .swiper-slide-active > button"
            );
            const singleCartonCard = document.querySelector(
              ".quantity-carousel .single-carton"
            );
            const singularVariantId = activeProductSlide?.getAttribute(
              "data-singular-variant-id"
            );
            if (singularVariantId?.length > 0) {
              singleCartonCard?.classList.remove("disabled");
            } else {
              singleCartonCard?.classList.add("disabled");
            }
          },
          slideNextTransitionEnd: (swiper) => {
            handleProductVariantId(swiper, "next");
          },
          slidePrevTransitionEnd: (swiper) => {
            handleProductVariantId(swiper, "prev");
          },
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      });

      swiperInstances[productSelector === "true" ? "product" : "quantity"] =
        productGallery;

      productSelectorBtns = carousel.querySelectorAll(".swiper-slide button");
      productSelectorBtns.forEach((btn, index) => {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          productGallery.slideToLoop(index);
        });
      });
    });
  }

  //   ------------ Main Carousel ---------------
  const mainCarousel = document.querySelectorAll(
    ".spp-main-carousel-container"
  );

  if (mainCarousel) {
    mainCarousel.forEach((carousel) => {
      const mainCarouselEl = carousel.querySelector(".spp-main-carousel");
      const mainCarouselThumbsEl = carousel.querySelector(
        ".spp-main-carousel-thumbs"
      );
      const mainCarouselPagination = carousel.querySelector(
        ".spp-main-carousel-pagination"
      );

      const mainCarouselThumbs = new Swiper(mainCarouselThumbsEl, {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainCarousel = new Swiper(mainCarouselEl, {
        spaceBetween: 10,
        thumbs: {
          swiper: mainCarouselThumbs,
        },
        pagination: {
          el: mainCarouselPagination,
        },
      });
    });
  }

  //   ------------ Subscription Toggle ---------------
  const subscriptionToggle = document.getElementById("spp-subscription-toggle");
  const sellingPlan = document.getElementById("spp-selling-plan");
  const subscriptionContent = document.querySelector(
    ".spp-subscription-section .content-area"
  );
  const standardPriceElement = document.querySelector(".spp-standard-price");
  const discountPriceElement = document.querySelector(".spp-discounted-price");

  if (subscriptionToggle && sellingPlan) {
    subscriptionToggle.addEventListener("change", function (event) {
      if (event.target.checked) {
        sellingPlan.removeAttribute("disabled");
        subscriptionContent.classList.remove("disable");
        standardPriceElement.classList.add("line-through");
        discountPriceElement.classList.remove("hidden");
      } else {
        sellingPlan.setAttribute("disabled", "true");
        subscriptionContent.classList.add("disable");
        standardPriceElement.classList.remove("line-through");
        discountPriceElement.classList.add("hidden");
      }
    });
  }

  //  ------------ Form Submission ---------------
  const priceButtons = document.querySelector("#step-4");
  const form = document.getElementById("subscription-product-picker-form");

  const handleScroll = () => {
    const formTop = form.getBoundingClientRect().top;
    const priceButtonsBottom = priceButtons.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (formTop < windowHeight / 2) {
      priceButtons.style.bottom = "20px";
    } else {
      priceButtons.style.bottom = "-140px";
    }

    if (priceButtonsBottom < windowHeight - 20) {
      priceButtons.classList.remove("is-stuck");
    } else {
      priceButtons.classList.add("is-stuck");
    }
  };

  if (priceButtons) {
    window.addEventListener("scroll", handleScroll);
  } else {
    window.removeEventListener("scroll", handleScroll);
  }
});
